export default __webpack_public_path__ + "8b5efd681299815ecb4593ecb677118c.svg";